import { journalEntryContract } from "@common/contracts/journal-entry.contract";
import { getBackendAPIClient } from "@lib/backendAPIClient";

export const journalEntryContractClient =
    getBackendAPIClient(journalEntryContract);
